const ApplicationModes = {
    SAVE: 1,
    SUBMIT: 2,
};

export default ApplicationModes;